export const GREEN_COLOR = '#7BBC64'
export const RED_COLOR = '#FC7D55'